import { render, staticRenderFns } from "./setColumnProperties.vue?vue&type=template&id=36edd8cf&scoped=true&"
import script from "./setColumnProperties.vue?vue&type=script&lang=js&"
export * from "./setColumnProperties.vue?vue&type=script&lang=js&"
import style0 from "./setColumnProperties.vue?vue&type=style&index=0&id=36edd8cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edd8cf",
  null
  
)

export default component.exports